import { render, staticRenderFns } from "./breakage.vue?vue&type=template&id=17fe5e53&"
import script from "./breakage.vue?vue&type=script&lang=js&"
export * from "./breakage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports